import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b8e91e54&"
import script from "./App.vue?vue&type=script&lang=javascript&"
export * from "./App.vue?vue&type=script&lang=javascript&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports